import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';

import { passwordToggleStyles, iconStyle } from './PasswordToggle.css';

interface PasswordToggleProps {
  showPassword: boolean;
  togglePassword: () => void;
}

export const PasswordToggle: React.FC<PasswordToggleProps> = ({ showPassword, togglePassword }) => (
  <button type="button" className={passwordToggleStyles} onClick={togglePassword} tabIndex={-1}>
    {showPassword ? (
      <FontAwesomeIcon className={iconStyle} icon={faEyeSlash} />
    ) : (
      <FontAwesomeIcon className={iconStyle} icon={faEye} />
    )}
  </button>
);
